export enum TipoDocumento {
  cpfCnpj,
  otherDocument,
}
